export const getPageVariant = isCashJourneySelected =>
  `${isCashJourneySelected ? "cash" : "leasing"} payment`;
